import './style.scss'

import React, { Component } from 'react'
import {
    canDeliver as _canDeliver,
    deadlinePassed as _deadlinePassed,
} from 'utilities/distribution'
import { getOffset, getWeekDays } from 'utilities/calendar'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

class Calendar extends Component {
    render() {
        const { weekDays, selectedDeliveryDate, setDate, dates, offset, deadline, t } = this.props
        return (
            <div className="calendar">
                <div className="calendar__days-of-week">
                    {weekDays.map((d, index) => {
                        return (
                            <div className="calendar__day-of-week" key={index}>
                                {d}
                            </div>
                        )
                    })}
                </div>
                <div className="calendar__days">
                    {dates.map(({ date, canDeliver, capacityStatus }, index) => {
                        const dayAvailable = _canDeliver({ date, canDeliver }, deadline)
                        const noCapacity = !canDeliver && capacityStatus === 'FULL'
                        const deadlinePassed = canDeliver && _deadlinePassed(date, deadline)
                        const daySelected = moment(date).isSame(selectedDeliveryDate, 'day')

                        const classes = classNames({
                            calendar__day: true,
                            'calendar__day--active': daySelected && dayAvailable,
                            'calendar__day--unavailable':
                                !dayAvailable && !noCapacity && !deadlinePassed,
                            'calendar__day--no-capacity': noCapacity,
                            'calendar__day--deadline-passed': deadlinePassed,
                            [`calendar__day--offset-${offset}`]: index === 0,
                        })

                        return (
                            <div key={date} className={classes}>
                                <button
                                    type="button"
                                    disabled={daySelected || !dayAvailable}
                                    onClick={() =>
                                        dayAvailable &&
                                        !daySelected &&
                                        setDate(moment(date).format('YYYY-MM-DD'))
                                    }
                                >
                                    {moment(date).format('D')}
                                </button>
                            </div>
                        )
                    })}
                </div>
                <div className="calendar__legend">
                    <span className="calendar__legend-item calendar__legend-item--available">
                        {t('calendarLabel_available')}
                    </span>
                    <span className="calendar__legend-item calendar__legend-item--unavailable">
                        {t('calendarLabel_unavailable')}
                    </span>
                    <span className="calendar__legend-item calendar__legend-item--no-capacity">
                        {t('calendarLabel_noCapacity')}
                    </span>
                </div>
            </div>
        )
    }
}

Calendar.propTypes = {
    selectedDeliveryDate: PropTypes.string,
    setDate: PropTypes.func,
    deadline: PropTypes.object,
    weekDays: PropTypes.array,
    onDateSelected: PropTypes.func,
    offset: PropTypes.number,
    dates: PropTypes.array,
    t: PropTypes.func,
}

const mapStateToProps = ({ distribution }) => {
    const dates = distribution.dates
    return {
        weekDays: getWeekDays(),
        offset: dates.length > 0 ? getOffset(dates[0].date) : 0,
        deadline: distribution.deadline,
        dates,
    }
}

export default connect(mapStateToProps)(withTranslation()(Calendar))
